import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { IDiscount } from '../../types/offer';

export const discount: TComputedPropMapper<IDiscount> = ({ offer }) => offer.discount;
